/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Describes a person's gender
 * @export
 */
export const GenderEnum = {
    None: 'None',
    Male: 'Male',
    Female: 'Female',
    NonBinary: 'NonBinary'
} as const;
export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];


export function instanceOfGenderEnum(value: any): boolean {
    for (const key in GenderEnum) {
        if (Object.prototype.hasOwnProperty.call(GenderEnum, key)) {
            if (GenderEnum[key as keyof typeof GenderEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GenderEnumFromJSON(json: any): GenderEnum {
    return GenderEnumFromJSONTyped(json, false);
}

export function GenderEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenderEnum {
    return json as GenderEnum;
}

export function GenderEnumToJSON(value?: GenderEnum | null): any {
    return value as any;
}

export function GenderEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): GenderEnum {
    return value as GenderEnum;
}

